export { default } from './OmiseTruemoney'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseTruemoney/index.js